import { render } from "./SessionExpiringModal.3.vue?vue&type=template&id=bee8bf14&ts=true"
import script from "./SessionExpiringModal.3.vue?vue&type=script&lang=ts"
export * from "./SessionExpiringModal.3.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__